import axios from 'axios';

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API + '/api'
});

let errorCount = 0;

apiClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      if (error.response.status === 401) {
        errorCount++;
        if (errorCount > 1) document.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default {
  apiClient
};
